import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'objArraySort'
})
export class ObjArraySortPipe implements PipeTransform {
  transform(array: any[], field: string): any[] {

    const nullElementList = [];
    const hasElementList = [];

    array.map(element => {
      element[field] == null ? nullElementList.push(element) : hasElementList.push(element);
    });

    hasElementList.sort((a: any, b: any) => {
      if (typeof a[field] === 'string') {
        // To not mutate original value
        const lowerCaseA = a[field] != null ? a[field].toLowerCase() : null;
        const lowerCaseB = b[field] != null ? b[field].toLowerCase() : null;

        if (lowerCaseA < lowerCaseB) {
          return -1;
        } else if (lowerCaseA > lowerCaseB) {
          return 1;
        } else {
          return 0;
        }
      } else {
        if (a[field] < b[field]) {
          return -1;
        } else if (a[field] > b[field]) {
          return 1;
        } else {
          return 0;
        }
      }
    });

    return hasElementList.concat(nullElementList);
  }
}
